import type React from 'react';
import { useEffect } from 'react';
import NotificationToast from './NotificationToast/NotificationToast';
import { useAppDispatch } from 'hooks';
import {
  addScreenReaderNotification,
  setDismissableNotification,
} from 'reducers/workflows';

interface DismissableNotificationToastProps {
  notification: string;
}

export const DismissableNotificationToast: React.FC<
  React.PropsWithChildren<DismissableNotificationToastProps>
> = ({ notification }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (notification) {
      dispatch(addScreenReaderNotification(notification));
    }
  }, [dispatch, notification]);

  if (!notification) return null;

  return (
    <NotificationToast
      content=''
      onDismiss={() => {
        dispatch(setDismissableNotification(''));
      }}
      title={notification}
    />
  );
};
